"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GooglePlacesAutocomplete = void 0;
const react_1 = __importStar(require("react"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const AutoComplete_1 = require("../AutoComplete");
const utils_1 = require("./utils");
const constants_1 = require("./constants");
const getSuggestions = debounce_1.default((searchText, setOptions, setIsLoading) => __awaiter(void 0, void 0, void 0, function* () {
    const { google } = window;
    const service = new google.maps.places.AutocompleteService();
    service.getPlacePredictions({ input: searchText }, (response) => {
        setOptions(response);
        setIsLoading(false);
    });
}), constants_1.DEFAULT_DEBOUNCE_DELAY);
const getPlaceDetails = (placeId, onSelect) => {
    const { google } = window;
    const service = new google.maps.Geocoder();
    service.geocode({
        placeId,
    }, (response) => {
        if (response && onSelect) {
            const { address_components: addressComponents, formatted_address: formattedAddress } = response[0];
            const location = utils_1.getLocationInfo(formattedAddress, addressComponents);
            onSelect(location);
        }
    });
};
exports.GooglePlacesAutocomplete = (props) => {
    const { onSelect } = props, restProps = __rest(props, ["onSelect"]);
    const [isLoading, setIsLoading] = react_1.useState(false);
    const [options, setOptions] = react_1.useState([]);
    react_1.useEffect(() => {
        const API_KEY = process.env.REACT_APP_GOOGLE_AUTOCOMPLETE_API_KEY;
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places`;
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);
    return (react_1.default.createElement(AutoComplete_1.AutoComplete, Object.assign({ loading: isLoading, options: options, label: "Location", getOptionLabel: option => option.description || '', onSelect: query => {
            if (query) {
                getPlaceDetails(query.place_id, onSelect);
            }
        }, onClear: () => onSelect && onSelect(undefined), onChange: value => {
            setIsLoading(true);
            getSuggestions(value, setOptions, setIsLoading);
        } }, restProps)));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR29vZ2xlUGxhY2VzQXV0b2NvbXBsZXRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvZ29vZ2xlLXBsYWNlcy1hdXRvY29tcGxldGUvR29vZ2xlUGxhY2VzQXV0b2NvbXBsZXRlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFFSCwrQ0FBbUQ7QUFDbkQsK0RBQXVDO0FBRXZDLGtEQUErQztBQUMvQyxtQ0FBMEM7QUFDMUMsMkNBQXFEO0FBR3JELE1BQU0sY0FBYyxHQUFHLGtCQUFRLENBQUMsQ0FBTyxVQUFVLEVBQUUsVUFBVSxFQUFFLFlBQVksRUFBRSxFQUFFO0lBQzdFLE1BQU0sRUFBRSxNQUFNLEVBQUUsR0FBRyxNQUFhLENBQUM7SUFFakMsTUFBTSxPQUFPLEdBQUcsSUFBSSxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxtQkFBbUIsRUFBRSxDQUFDO0lBQzdELE9BQU8sQ0FBQyxtQkFBbUIsQ0FBQyxFQUFFLEtBQUssRUFBRSxVQUFVLEVBQUUsRUFBRSxDQUFDLFFBQWEsRUFBRSxFQUFFO1FBQ25FLFVBQVUsQ0FBQyxRQUFRLENBQUMsQ0FBQztRQUNyQixZQUFZLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDdEIsQ0FBQyxDQUFDLENBQUM7QUFDTCxDQUFDLENBQUEsRUFBRSxrQ0FBc0IsQ0FBQyxDQUFDO0FBRTNCLE1BQU0sZUFBZSxHQUFHLENBQUMsT0FBZSxFQUFFLFFBQStCLEVBQUUsRUFBRTtJQUMzRSxNQUFNLEVBQUUsTUFBTSxFQUFFLEdBQUcsTUFBYSxDQUFDO0lBRWpDLE1BQU0sT0FBTyxHQUFHLElBQUksTUFBTSxDQUFDLElBQUksQ0FBQyxRQUFRLEVBQUUsQ0FBQztJQUUzQyxPQUFPLENBQUMsT0FBTyxDQUNiO1FBQ0UsT0FBTztLQUNSLEVBQ0QsQ0FBQyxRQUFhLEVBQUUsRUFBRTtRQUNoQixJQUFJLFFBQVEsSUFBSSxRQUFRLEVBQUU7WUFDeEIsTUFBTSxFQUFFLGtCQUFrQixFQUFFLGlCQUFpQixFQUFFLGlCQUFpQixFQUFFLGdCQUFnQixFQUFFLEdBQUcsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ25HLE1BQU0sUUFBUSxHQUFHLHVCQUFlLENBQUMsZ0JBQWdCLEVBQUUsaUJBQWlCLENBQUMsQ0FBQztZQUN0RSxRQUFRLENBQUMsUUFBUSxDQUFDLENBQUM7U0FDcEI7SUFDSCxDQUFDLENBQ0YsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVXLFFBQUEsd0JBQXdCLEdBQUcsQ0FBQyxLQUF3QyxFQUFFLEVBQUU7SUFDbkYsTUFBTSxFQUFFLFFBQVEsS0FBbUIsS0FBSyxFQUFuQixTQUFTLFVBQUssS0FBSyxFQUFsQyxZQUEwQixDQUFRLENBQUM7SUFDekMsTUFBTSxDQUFDLFNBQVMsRUFBRSxZQUFZLENBQUMsR0FBRyxnQkFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ2xELE1BQU0sQ0FBQyxPQUFPLEVBQUUsVUFBVSxDQUFDLEdBQUcsZ0JBQVEsQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUUzQyxpQkFBUyxDQUFDLEdBQUcsRUFBRTtRQUNiLE1BQU0sT0FBTyxHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUMscUNBQXFDLENBQUM7UUFDbEUsTUFBTSxNQUFNLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQztRQUNoRCxNQUFNLENBQUMsR0FBRyxHQUFHLCtDQUErQyxPQUFPLG1CQUFtQixDQUFDO1FBQ3ZGLE1BQU0sQ0FBQyxLQUFLLEdBQUcsSUFBSSxDQUFDO1FBRXBCLFFBQVEsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBRWxDLE9BQU8sR0FBRyxFQUFFO1lBQ1YsUUFBUSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsTUFBTSxDQUFDLENBQUM7UUFDcEMsQ0FBQyxDQUFDO0lBQ0osQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBRVAsT0FBTyxDQUNMLDhCQUFDLDJCQUFZLGtCQUNYLE9BQU8sRUFBRSxTQUFTLEVBQ2xCLE9BQU8sRUFBRSxPQUFPLEVBQ2hCLEtBQUssRUFBQyxVQUFVLEVBQ2hCLGNBQWMsRUFBRSxNQUFNLENBQUMsRUFBRSxDQUFDLE1BQU0sQ0FBQyxXQUFXLElBQUksRUFBRSxFQUNsRCxRQUFRLEVBQUUsS0FBSyxDQUFDLEVBQUU7WUFDaEIsSUFBSSxLQUFLLEVBQUU7Z0JBQ1QsZUFBZSxDQUFDLEtBQUssQ0FBQyxRQUFRLEVBQUUsUUFBUSxDQUFDLENBQUM7YUFDM0M7UUFDSCxDQUFDLEVBQ0QsT0FBTyxFQUFFLEdBQUcsRUFBRSxDQUFDLFFBQVEsSUFBSSxRQUFRLENBQUMsU0FBUyxDQUFDLEVBQzlDLFFBQVEsRUFBRSxLQUFLLENBQUMsRUFBRTtZQUNoQixZQUFZLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDbkIsY0FBYyxDQUFDLEtBQUssRUFBRSxVQUFVLEVBQUUsWUFBWSxDQUFDLENBQUM7UUFDbEQsQ0FBQyxJQUNHLFNBQVMsRUFDYixDQUNILENBQUM7QUFDSixDQUFDLENBQUMifQ==